import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.4rem 0.4rem 0 0.4rem;
    gap: .5rem;
    width: 100%;
    height: 3.5rem !important;
`
